if (!customElements.get('tb-experience-centers')) {
  class TrainbotExperienceCenters extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('[data-filters]');
      this.country = this.querySelector('[data-country-filter]');
      this.search = this.querySelector('[data-search]');
      this.statusCount = this.querySelector('[data-status-count]');
      this.statusDetail = this.querySelector('[data-status-detail]');
      this.emptyRow = this.querySelector('[data-empty-row]');
      this.emptyText = this.querySelector('[data-empty-text]');
      if (!this.form || !this.country || !this.search || !this.statusCount || !this.statusDetail || !this.emptyRow || !this.emptyText) return;

      this.records = Array.from(this.querySelectorAll('[data-center]'), (element) => ({
        element,
        country: this.normalize(element.dataset.country),
        text: this.normalize(element.textContent)
      }));
      for (const option of Array.from(this.country.options)) {
        if (option.value === '---') option.remove();
      }
      const countries = new Set(Array.from(this.country.options, (option) => this.normalize(option.value)));
      for (const record of this.records) {
        if (!countries.has(record.country)) {
          const name = record.element.dataset.country.trim();
          this.country.add(new Option(name, name));
          countries.add(record.country);
        }
      }

      this.country.addEventListener('change', () => this.filter(), options);
      this.search.addEventListener('input', () => this.filter(), options);
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.filter();
      }, options);
      this.form.addEventListener('reset', (event) => {
        event.preventDefault();
        this.country.value = '';
        this.search.value = '';
        this.filter();
        this.country.focus();
      }, options);
      this.filter();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    normalize(value = '') {
      return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    filter() {
      const country = this.normalize(this.country.value);
      const terms = this.normalize(this.search.value).split(/\s+/).filter(Boolean);
      let matches = 0;
      for (const record of this.records) {
        const visible = (!country || country === record.country) && terms.every((term) => record.text.includes(term));
        record.element.hidden = !visible;
        if (visible) matches += 1;
      }
      const label = matches === 1 ? this.dataset.resultSingular : this.dataset.resultPlural;
      let message = this.dataset.emptyMessage;
      if (terms.length) message = this.dataset.noMatches;
      else if (country) {
        const name = this.country.selectedOptions[0]?.textContent || this.country.value;
        message = this.dataset.countryEmpty.replaceAll('[country]', name);
      }
      this.emptyText.textContent = message;
      this.emptyRow.hidden = matches !== 0;
      this.statusCount.textContent = `${matches} ${label}`;
      this.statusDetail.textContent = matches ? '' : `. ${message}`;
    }
  }
  customElements.define('tb-experience-centers', TrainbotExperienceCenters);
}
